/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from '@shared/DbBaseObject.js';


export default class ClientAccessSettings extends DbBaseObject{


	canCreateNotes: boolean
	canCreateActionItems: boolean
	canCreateSessionDetails: boolean
	canCreateSections: boolean

	canEdit: boolean


	constructor() {
		super();
		this.setDefaults()
	}

	setDefaults(){
		this.canEdit = false
		this.canCreateNotes = true
		this.canCreateActionItems = false
		this.canCreateSessionDetails = false
		this.canCreateSections = false
	}

	setAllRead(){
		this.setDefaults()
	}

	setAllWrite(){
		this.canEdit = true
		this.canCreateNotes = true
		this.canCreateActionItems = true
		this.canCreateSessionDetails = true
		this.canCreateSections = true
	}
}



